var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.esqueletoAtivo || _vm.items.length
    ? _c("BaseSummaryCard", {
        staticClass: "asset-kpis mb-4",
        attrs: {
          "style-card": "bordered",
          items: _vm.itemsComEsqueleto,
          loading: _vm.esqueletoAtivo
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }